export default __webpack_public_path__ + "static/media/android.bbb01a94.jpg";